import {
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Stack,
	Typography,
} from "@mui/material"

export const DeleteTableDataConfirmationModal = (props: {
	isOpen: boolean
	onClose: (result: boolean) => void
	isButtonLoading: boolean
}) => {
	return (
		<Dialog open={props.isOpen} onClose={() => props.onClose(false)} aria-label="delete table data modal">
			<DialogTitle>テーブルのデータを全て削除</DialogTitle>
			<DialogContent>
				<Stack direction="column" alignItems="left" spacing={1}>
					<Typography>テーブルのデータを全て削除します。</Typography>
					<Typography>
						・要注意 :
						取り戻しはできませんので、予めCSVファイルとしてダウンロードするなど、バックアップを用意しておいてください。
					</Typography>
					<Typography>
						・要注意 : 他のテーブルでこちらのデータが参照されている場合、最適化ができなくなる場合もあります。
					</Typography>
				</Stack>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => props.onClose(false)} disabled={props.isButtonLoading}>
					データを削除しない
				</Button>
				<Button onClick={() => props.onClose(true)} disabled={props.isButtonLoading}>
					データを削除する{" "}
					{props.isButtonLoading ? <CircularProgress size={24} style={{ marginLeft: "0.5em" }} /> : <></>}
				</Button>
			</DialogActions>
		</Dialog>
	)
}
